import React from 'react';
import { ShellBrandLogo } from '@/features/shell/ShellBrandLogo';

/** Shared brand header for auth screens (login, signup, password flows). */
export function AuthBrandHeader({ subtitle }: { subtitle?: string }) {
  return (
    <div className="flex flex-col items-center mb-10 text-center">
      <ShellBrandLogo linked={false} className="justify-center" />
      {subtitle ? (
        <p className="text-sm text-muted-foreground max-w-sm mt-3">{subtitle}</p>
      ) : null}
    </div>
  );
}
